module.exports = __webpack_public_path__ + "838b3912c1ba2f5e7ffc4abac15c3adc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss04.jpg
// module id = 710
// module chunks = 0